import React, { Component } from 'react'
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';

import Input from 'Flow2/components/UI/Input/Input';

const mapStateToProps = (state, ownProps) => {
	return {
		config: state.ui.config,
		rooms: state.rooms.rooms,
        projects: state.projects.projects,
	}
}

const projectOverview = (props) => {
    let content = [];
    let ref = {};

    if (props.config.METADATA_PROJECT_OVERVIEW) {
        let options = [{ value: "", displayValue: "-" }];
        let selected = window.location.pathname.match(/(\/\w+\/[0-9]+)$/);

        if (props.originalObject.projectids) {
            props.originalObject.projectids.forEach(id => {
                if (props.projects[id]) {
                    options.push({ value: "/project/" + id, displayValue: props.intl.formatMessage({ id: "common.project" }) + " - " + props.projects[id].name });
                }
            });
            props.originalObject.projectids.forEach(id => {
                if (props.rooms[id]) {
                    options.push({ value: "/room/" + id, displayValue: props.intl.formatMessage({ id: "common.room" }) + " - " + props.rooms[id].title });
                }
            });
        }

        const select = (
            <Input
                key={"ProjectSelect"+props.id}
                value={selected ? selected[1] : ""}
                elementType="select"
                elementConfig={{ options: options }}
                changed={(event) => {
                    if (event.target.value) {
                        let name = event.target.value.match(/(\w+)/)[1] + "Id";
                        let id = event.target.value.match(/([0-9]+)/)[1];
                        let ref = { [name]: id }

                        props.history.push({
                            pathname: event.target.value,
                            state: { id: id },
                            ...ref
                        });
                    }
                }} />
        );

        return (
            <tr key={"ProjectOverview"+props.id}>
                <th className={[].join(' ')}><FormattedMessage id={"common.projects"} />/<FormattedMessage id={"common.rooms"} /></th>
                <td className={[].join(' ')}>{select}</td>
            </tr>
        );
    }
    
    return "";
}

export const ProjectOverview = connect(mapStateToProps)(injectIntl(withRouter(projectOverview)));
